/**
 * Whether the next workout lands today or tomorrow.
 *
 * Once a workout is finished, the program's next entry is not due again until
 * the following day, so the home card should stop saying "TODAY". The
 * comparison is done here rather than on the server because only the client
 * knows the user's timezone — a UTC-side comparison would flip at the wrong
 * hour for most of the world.
 */
export function isSameLocalDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate();
}

/** `TODAY` unless a workout was already completed today, then `TOMORROW`. */
export function nextDayLabel(
  lastCompletedAt: number | null | undefined,
  now: Date = new Date(),
): 'TODAY' | 'TOMORROW' {
  if (lastCompletedAt == null) return 'TODAY';
  const completed = new Date(lastCompletedAt * 1000);
  return isSameLocalDay(completed, now) ? 'TOMORROW' : 'TODAY';
}
